import {ContactProfileTab} from "../../../contact/model/ContactProfileTab";
import {Lead} from "../../model/Lead";
import {
    ConversionLogAwareContactProfileController,
    ConversionLogAwareContactProfileScope
} from "../../../contact/controller/contact_profile/impl/ConversionLogAwareContactProfileController";
import {CampaignActionLogServiceName} from "../../../utils/names/serviceNames";
import {CampaignActionLogService} from "../../../campaigns_service/service/CampaignActionLogService";
import {ContactType} from "../../../contact/model/Contact";

interface Scope extends ConversionLogAwareContactProfileScope<Lead> {

}

export class LeadProfileController extends ConversionLogAwareContactProfileController<Lead, Scope> {

    static instanceConstructor = [
        '$scope',
        '$routeParams',
        'selectedContact',
        CampaignActionLogServiceName,
        LeadProfileController
    ];


    constructor($scope: Scope,
                $routeParams: ng.route.IRouteParamsService,
                lead: Lead,
                campaignActionLogService: CampaignActionLogService) {
        super($scope, $routeParams, lead, campaignActionLogService);
    }

    protected tabs(): ContactProfileTab[] {
        return [
            ContactProfileTab.BASIC,
            ContactProfileTab.DATE_FIELDS,
            ContactProfileTab.CAMPAIGN_LOG
        ]
    }

    protected contactType(): ContactType {
        return ContactType.LEAD;
    }

}